import { useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useCarGroupsByLocationsQuery, useProductQuery } from "../../../../../../api/services";
import { FormAutocomplete } from "../../../../../../components/fields";
import { CarGroupType } from "../../../../../../types";
import { IFormValues } from "../../../../types";
import {LOCALE_DATE_TIME_FORMAT} from "../../../../../../utils";
import { editPendingBookingRce } from "../../../../recoil";
import {useEffect} from "react";
import { useRecoilValue } from "recoil";

const FormCarGroup = () => {

    const { t } = useTranslation('booking');

    const isPendingBookingRce = useRecoilValue<boolean | undefined>(editPendingBookingRce);

    const rentalType = useWatch<IFormValues, "basicDetails.rentalType">(({
        name: 'basicDetails.rentalType'
    }));
    const pickupLocation = useWatch<IFormValues, "basicDetails.pickupLocation">({
        name: 'basicDetails.pickupLocation'
    });
    const dropoffLocation = useWatch<IFormValues, "basicDetails.dropoffLocation">({
        name: 'basicDetails.dropoffLocation'
    });
    const vehicleType = useWatch<IFormValues, "basicDetails.vehicleCategory">({
        name: 'basicDetails.vehicleCategory'
    });
    const requestDate = useWatch<IFormValues, "basicDetails.bookingDateTime">({
        name: 'basicDetails.bookingDateTime'
    });
    const pickupDate = useWatch<IFormValues, "basicDetails.pickupDate">({
        name: 'basicDetails.pickupDate'
    });
    const dropoffDate = useWatch<IFormValues, "basicDetails.dropoffDate">({
        name: 'basicDetails.dropoffDate'
    });
    const tenant = useWatch<IFormValues, 'basicDetails.tenant'>({
        name: 'basicDetails.tenant'
    });
    const dealer = useWatch<IFormValues, 'basicDetails.dealer'>({
        name: 'basicDetails.dealer'
    });

    const productQuery = useProductQuery(
        {
            segment: rentalType,
            businessContinuityInsToolMode: false,
            tenant: tenant as string,
            dealer: dealer as string
        },
        {
            refetchOnMount: false
        }
    );

    const carGroupsQuery = useCarGroupsByLocationsQuery(
        {
            pickupLocation: pickupLocation?.id,
            dropoffLocation: dropoffLocation?.id,
            requestDate: requestDate?.isValid() ? requestDate?.toISOString() : undefined,
            pickupDate: pickupDate?.isValid() ? pickupDate?.format(LOCALE_DATE_TIME_FORMAT) : undefined,
            dropoffDate: dropoffDate?.isValid() ? dropoffDate?.format(LOCALE_DATE_TIME_FORMAT) : undefined,
            products: productQuery.data?.products,
            tenant: tenant as string,
            dealer: dealer as string
        },
        {
            enabled: !!(
                productQuery.data?.products &&
                pickupDate &&
                dropoffDate &&
                pickupLocation &&
                dropoffLocation
                && tenant && dealer
            ),
            refetchOnMount: false
        }
    );

    return (
        <FormAutocomplete<IFormValues>
            name="basicDetails.carGroup"
            disabled={isPendingBookingRce}
            label={t('label.carGroup')}
            options={carGroupsQuery.data?.carGroups.filter(v => v.bookedVehicleType === vehicleType) ?? []}
            loading={carGroupsQuery.isFetching}
            getOptionLabel={(option) =>
                option.type === CarGroupType.Acriss ? `${option.acrissCode} - ${option.acrissLabel}` : `${option.sippCode} - ${option.sippLabel}`
            }
            isOptionEqualToValue={(option, value) => {
                if (option.type === CarGroupType.Acriss)
                    return option?.acrissCode === value?.acrissCode;
                else {
                    return option?.sippCode === value?.sippCode;
                }
            }}
        />
    )
}

export default FormCarGroup;
